import Text from '../../Text'

import * as styles from './ChatroomDateDivider.module.css'

function ChatroomDateDivider({ label }) {
  return label ? (
    <div className={styles.chatroomDateDivider}>
      <Text isSecondary className={styles.label}>
        {label}
      </Text>
    </div>
  ) : null
}

export default ChatroomDateDivider
